import { useState } from 'react';
import DrawdownPanel from '../DrawdownPanel/DrawdownPanel';
import { TopUpDeclined } from '../RequestMoreFundsPanel/TopUpStatusMessages/TopUpDeclined';
import TopUpStatusMessage from '../RequestMoreFundsPanel/TopUpStatusMessages/TopUpStatusMessage';
import { Redirect } from 'react-router-dom';
import { Button } from '@iwoca/orion';
import {
    CreateNewApplicationForm,
    TApplicationStatus
} from '../CreateNewApplicationForm/CreateNewApplicationForm';
import messages from './TopUpForm.messages';
import { FormattedMessage } from 'react-intl';

export const TopUpForm = ({
    formHeader,
    accountId
}: {
    formHeader?: React.ReactNode;
    accountId: string;
}) => {
    const [applicationStatus, setApplicationStatus] =
        useState<TApplicationStatus>(null);

    switch (applicationStatus) {
        case 'auto_approved':
            return <DrawdownPanel />;
        case 'auto_declined':
            return <TopUpDeclined />;
        case 'requires_documents':
            return <Redirect to="/apply-flexi-loan/?topup=true" />;
        case 'docs_complete':
            return (
                <>
                    <TopUpStatusMessage
                        heading={
                            <FormattedMessage
                                {...messages.docsCompleteHeading}
                            />
                        }
                        description={
                            <FormattedMessage
                                {...messages.docsCompleteDescription}
                            />
                        }
                    />
                    <Button onClick={() => window.location.reload()}>
                        <FormattedMessage {...messages.backToDashboard} />
                    </Button>
                </>
            );
        case 'unknown':
            return (
                <TopUpStatusMessage
                    heading={<FormattedMessage {...messages.errorHeading} />}
                    ctaText={<FormattedMessage {...messages.errorCTA} />}
                />
            );
        default:
            return (
                <>
                    {formHeader}
                    <CreateNewApplicationForm
                        accountId={accountId}
                        setApplicationStatus={setApplicationStatus}
                    />
                </>
            );
    }
};
